// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"ConveniosGeral_containerPrincipal__Zi+Wa","divConvenios":"ConveniosGeral_divConvenios__Vrbog"};